import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faArrowDown,
    faArrowUp,
    faCheck,
    faGripVertical,
    faPen,
    faSort,
    faTrashCan,
    faUserGroup,
    faUserPlus,
    faXmark,
} from '@fortawesome/free-solid-svg-icons';

import MyModalCreateEleve from './EleveModal/MyModalCreateEleve';
import MyModalDeleteEleve from './EleveModal/MyModalDeleteEleve';
import MyModalModifEleve from './EleveModal/MyModalModifEleve';

import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios';
import { orderStudents } from '../utils/studentOrder';

export default function CardTable(props) {
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [modalIsOpen2, setIsOpen2] = React.useState(false);
    const [modalIsOpen3, setIsOpen3] = React.useState(false);

    const [eleveSelect, setEleveSelect] = React.useState('');
    const [isReordering, setIsReordering] = React.useState(false);
    const [isSavingOrder, setIsSavingOrder] = React.useState(false);
    const [orderedEleves, setOrderedEleves] = React.useState([]);
    const [draggedEleveId, setDraggedEleveId] = React.useState(null);
    const [orderFeedback, setOrderFeedback] = React.useState(null);
    const feedbackTimer = React.useRef(null);

    const allEleve = useSelector(state => state.eleveDetail.arr)
    const classes = useSelector(state => state.classeDetail.arr)
    const compte = useSelector(state => state.userGlobal.user)
    const userConnected = useSelector(state => state.userConnected.user_connected)
    const dispatch = useDispatch()

    const eleve = isReordering ? orderedEleves : orderStudents(allEleve, props.position)

    React.useEffect(() => {
        if (!isReordering) {
            setOrderedEleves(orderStudents(allEleve, props.position));
        }
    }, [allEleve, props.position, isReordering]);

    React.useEffect(() => () => {
        if (feedbackTimer.current) window.clearTimeout(feedbackTimer.current);
    }, []);

    function showOrderFeedback(type, message) {
        if (feedbackTimer.current) window.clearTimeout(feedbackTimer.current);
        setOrderFeedback({ type, message });
        feedbackTimer.current = window.setTimeout(() => setOrderFeedback(null), 3000);
    }

    function openFromParent(modalNumber, row) {
        switch(modalNumber) {
          case 1:
            setIsOpen(true);
            break;
          case 2:
            setIsOpen2(true);
            setEleveSelect(row);
            break;
          case 3:
            setIsOpen3(true);
            setEleveSelect(row);
            break;
          default:
            break;
        }
    }

    function handleCloseModal(event, data) {
        switch(data) {
          case 1:
            setIsOpen(false);
            break;
          case 2:
            setIsOpen2(false);
            break;
          case 3:
            setIsOpen3(false);
            break;
          default:
            break;
        }
    }

    function beginReordering() {
        setOrderedEleves(orderStudents(allEleve, props.position));
        setIsReordering(true);
    }

    function cancelReordering() {
        setOrderedEleves(orderStudents(allEleve, props.position));
        setDraggedEleveId(null);
        setIsReordering(false);
    }

    function moveEleve(currentIndex, nextIndex) {
        if (nextIndex < 0 || nextIndex >= orderedEleves.length || currentIndex === nextIndex) return;

        setOrderedEleves((currentEleves) => {
            const nextEleves = [...currentEleves];
            const [movedEleve] = nextEleves.splice(currentIndex, 1);
            nextEleves.splice(nextIndex, 0, movedEleve);
            return nextEleves;
        });
    }

    function dropEleve(targetEleveId) {
        if (draggedEleveId === null || String(draggedEleveId) === String(targetEleveId)) return;

        setOrderedEleves((currentEleves) => {
            const sourceIndex = currentEleves.findIndex((item) => String(item.id_eleve) === String(draggedEleveId));
            const targetIndex = currentEleves.findIndex((item) => String(item.id_eleve) === String(targetEleveId));
            if (sourceIndex < 0 || targetIndex < 0) return currentEleves;

            const nextEleves = [...currentEleves];
            const [movedEleve] = nextEleves.splice(sourceIndex, 1);
            nextEleves.splice(targetIndex, 0, movedEleve);
            return nextEleves;
        });
        setDraggedEleveId(null);
    }

    function savePosition() {
        if (isSavingOrder) return;

        const position = orderedEleves.map((item) => item.id_eleve).join(',');
        const formData = new FormData();
        formData.append('id_classe', props.idClasse);
        formData.append('id_compte', compte.id_compte);
        formData.append('id_user', userConnected.id_user);
        formData.append('position', position);

        setIsSavingOrder(true);
        axios.post('https://eps.acces-editions.com/api/updateMyClassePosition', formData)
            .then(() => {
                dispatch({
                    type: 'user/classeDetail',
                    payload: classes.map((classe) => (
                        String(classe.id_classe) === String(props.idClasse)
                            ? { ...classe, position }
                            : classe
                    )),
                });
                if (props.onPositionChange) props.onPositionChange(position);
                setIsReordering(false);
                showOrderFeedback('success', 'Ordre des élèves enregistré');
            })
            .catch(() => {
                showOrderFeedback('error', "L'ordre des élèves n'a pas pu être enregistré");
            })
            .finally(() => setIsSavingOrder(false));
    }

    return (
        <>
            <MyModalCreateEleve
                IsModalOpened={modalIsOpen}
                onCloseModal={handleCloseModal}
                classeInfo={props}
                key={modalIsOpen ? 'create-student-open' : 'create-student-closed'}
            />
            <MyModalModifEleve
                IsModalOpened={modalIsOpen2}
                onCloseModal={handleCloseModal}
                eleveInfo={eleveSelect}
                classeInfo={props}
                key={modalIsOpen2 ? 'edit-student-open' : 'edit-student-closed'}
            />
            <MyModalDeleteEleve
                IsModalOpened={modalIsOpen3}
                onCloseModal={handleCloseModal}
                eleveInfo={eleveSelect}
                classeInfo={props}
                key={modalIsOpen3 ? 'delete-student-open' : 'delete-student-closed'}
            />

            <section className="ae-workspace-card">
                <header className="ae-workspace-card-header">
                    <span className="ae-workspace-card-icon"><FontAwesomeIcon icon={faUserGroup} /></span>
                    <div>
                        <h2>Liste des élèves</h2>
                        <p>{isReordering ? "Déplacez les élèves pour définir leur ordre dans l'application." : 'Ajoutez, modifiez ou retirez les élèves rattachés à cette classe.'}</p>
                    </div>
                    <div className="ae-workspace-header-actions">
                        {isReordering ? (
                            <>
                                <button type="button" className="ae-workspace-order-cancel" onClick={cancelReordering} disabled={isSavingOrder}>
                                    <FontAwesomeIcon icon={faXmark} />
                                    <span>Annuler</span>
                                </button>
                                <button type="button" className="ae-workspace-primary-button" onClick={savePosition} disabled={isSavingOrder}>
                                    <FontAwesomeIcon icon={faCheck} />
                                    <span>{isSavingOrder ? 'Enregistrement…' : "Enregistrer l'ordre"}</span>
                                </button>
                            </>
                        ) : (
                            <>
                                {eleve.length > 1 && (
                                    <button type="button" className="ae-workspace-order-button" onClick={beginReordering}>
                                        <FontAwesomeIcon icon={faSort} />
                                        <span>Modifier l'ordre</span>
                                    </button>
                                )}
                                <button type="button" className="ae-workspace-primary-button" onClick={() => openFromParent(1)}>
                                    <FontAwesomeIcon icon={faUserPlus} />
                                    <span>Ajouter un élève</span>
                                </button>
                            </>
                        )}
                    </div>
                </header>

                {orderFeedback && (
                    <div
                        className={`ae-workspace-order-feedback ae-workspace-order-feedback--${orderFeedback.type}`}
                        role={orderFeedback.type === 'error' ? 'alert' : 'status'}
                        aria-live="polite"
                    >
                        <FontAwesomeIcon icon={orderFeedback.type === 'success' ? faCheck : faXmark} />
                        <span>{orderFeedback.message}</span>
                    </div>
                )}

                <div className="ae-workspace-card-body">
                    {eleve.length > 0 ? (
                        <div className="ae-workspace-table-wrap">
                            <table className={`ae-workspace-table${isReordering ? ' ae-workspace-order-table' : ''}`}>
                                <thead>
                                    <tr>
                                        {isReordering && <th>Position</th>}
                                        <th>Prénom</th>
                                        <th>Nom</th>
                                        <th>Niveau</th>
                                        <th>{isReordering ? 'Déplacer' : 'Actions'}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {eleve.map((row, index) => (
                                        <tr
                                            key={row.id_eleve}
                                            className={isReordering ? 'ae-workspace-order-row' : ''}
                                            draggable={isReordering}
                                            onDragStart={(event) => {
                                                setDraggedEleveId(row.id_eleve);
                                                event.dataTransfer.effectAllowed = 'move';
                                            }}
                                            onDragOver={(event) => {
                                                if (isReordering) event.preventDefault();
                                            }}
                                            onDrop={(event) => {
                                                event.preventDefault();
                                                dropEleve(row.id_eleve);
                                            }}
                                            onDragEnd={() => setDraggedEleveId(null)}
                                        >
                                            {isReordering && (
                                                <td data-label="Position">
                                                    <span className="ae-workspace-position-number">{index + 1}</span>
                                                </td>
                                            )}
                                            <td data-label="Prénom"><strong>{row.prenom}</strong></td>
                                            <td data-label="Nom">{row.nom}</td>
                                            <td data-label="Niveau">{row.niveau}</td>
                                            <td data-label={isReordering ? 'Déplacer' : 'Actions'}>
                                                {isReordering ? (
                                                    <div className="ae-workspace-order-controls">
                                                        <span className="ae-workspace-drag-handle" title="Glisser pour déplacer" aria-hidden="true">
                                                            <FontAwesomeIcon icon={faGripVertical} />
                                                        </span>
                                                        <button type="button" onClick={() => moveEleve(index, index - 1)} disabled={index === 0} aria-label={`Monter ${row.prenom}`}>
                                                            <FontAwesomeIcon icon={faArrowUp} />
                                                        </button>
                                                        <button type="button" onClick={() => moveEleve(index, index + 1)} disabled={index === eleve.length - 1} aria-label={`Descendre ${row.prenom}`}>
                                                            <FontAwesomeIcon icon={faArrowDown} />
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div className="ae-workspace-row-actions">
                                                        <button type="button" className="ae-workspace-primary-button" onClick={() => openFromParent(2, row)}>
                                                            <FontAwesomeIcon icon={faPen} />
                                                            <span>Modifier</span>
                                                        </button>
                                                        <button type="button" className="ae-workspace-danger-button" onClick={() => openFromParent(3, row)}>
                                                            <FontAwesomeIcon icon={faTrashCan} />
                                                            <span>Retirer</span>
                                                        </button>
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p className="ae-workspace-empty">Vous n'avez aucun élève dans cette classe.</p>
                    )}
                </div>
            </section>
        </>
    );
}
